import PropTypes from 'prop-types'
import React, {useEffect, useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

import "./PersonAvatar.scss"
function PersonAvatar( { onFinishTalking = () => {},
                           avatar,
                           name,
                           jobtitle,
                           speak = '',
                           delayIn= 0.5,
                           delayOut= 10,
                           showQuestionIndicator= false,
                           onQuestionIndicatorClick = () => {},
                           questionSymbol= faQuestionCircle,
                           bubblePosition = '',
                       } ) {
    const [currentRepSpeech, setCurrentRepSpeech] = useState( speak)
    const [speek, setSpeek] =  useState()

    const makeAvatarSpeak = (text, delayIn = 0.2,  delayOut = 0) => {
        let t1,t2
        setCurrentRepSpeech(' ... ')

        t1 = setTimeout( () => {
            setCurrentRepSpeech(text)
            setSpeek('show')
        }, delayIn * 1000)
        if (delayOut > 0 ) {
            t2 =   setTimeout(() => {
                onFinishTalking()
            }, delayOut * 1000)
        }
        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
        }
    }
    useEffect(() => {
        makeAvatarSpeak(speak, delayIn, delayOut)
    }, [speak])


    const markUp  = (avatarSpeech) => ({
        __html: avatarSpeech
    })
    return <div className="person-avatar-container">

        {currentRepSpeech  && <div className={`person-avatar-bubble ${speek} ${bubblePosition}`} onClick={() => {setCurrentRepSpeech(null)} }>
            <div className={"person-avatar-bubble-speech "} dangerouslySetInnerHTML={markUp(currentRepSpeech)}>
            </div>
        </div>}
        {showQuestionIndicator === true && <div className={"person-avatar-questionindicator"} onClick={() => {
            if (onQuestionIndicatorClick) {
                onQuestionIndicatorClick()
            }
        }
        }>
            <FontAwesomeIcon icon={questionSymbol} color={'lightblue'}/>

        </div>}
        <div className='person-avatar-img'>
            <img src={avatar}  alt={name}/>
        </div>

        <span className='person-avatar-name'>{name}</span>
        <span className='person-avatar-role'>{jobtitle}</span>
    </div>
}
export default PersonAvatar;

PersonAvatar.propTypes = {
    avatar: PropTypes.string,
    name: PropTypes.string,
    role: PropTypes.string
}
